<template>
  <div>
    <div class="mb-6">
      <p class="font-medium text-base mb-2">
        {{ title }}
      </p>
      <div v-html="legendsHtml" ref="legendsRef"></div>
    </div>
    <config-line-chart
      :chart-data="chartData"
      @generate-legend-line-chart="generateLegends"
      ref="lineChart"
    ></config-line-chart>
  </div>
</template>
<script>
import ConfigLineChart from "./ConfigLineChart";
export default {
  components: { ConfigLineChart },
  props: ["chartData", "title"],
  data() {
    return {
      legendsHtml: ""
    };
  },
  methods: {
    generateLegends(legend) {
      this.legendsHtml = legend;
    }
  }
};
</script>
